var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecharge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.9 29.9",
    style: {
      enableBackground: "new 0 0 33.9 29.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E10092;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "recharge",
    className: "st0",
    d: "M2.5,15.4L1.7,16c-0.1,0.1-0.3,0.1-0.4,0.1c-0.1,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.1-0.3-0.1-0.4 c0-0.1,0.1-0.3,0.2-0.4l1.6-1.3c0.2-0.2,0.5-0.2,0.7,0l1.6,1.3c0.1,0.1,0.2,0.2,0.2,0.4c0,0.1,0,0.3-0.1,0.4 c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.3-0.1-0.3-0.1l-0.7-0.6c0.3,7.2,6.2,12.9,13.4,12.9c6.2,0,11.5-4.2,13-10.1 c0-0.1,0.1-0.3,0.2-0.3c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.1,0.5,0.4,0.4,0.7C29.4,25,23.6,29.5,17,29.5C9.1,29.5,2.7,23.2,2.5,15.4 L2.5,15.4z M18.2,21.1l-1.8-3c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.1-0.4-0.3-0.6-0.3 c-0.2-0.1-0.5-0.1-0.7-0.1h-0.9v-1.1h1.6c0.3,0,0.5,0,0.8-0.1c0.2-0.1,0.5-0.2,0.7-0.4c0.2-0.2,0.4-0.3,0.5-0.6 c0.1-0.2,0.2-0.5,0.3-0.7h-3.8v-1.1H17c0-0.2-0.1-0.4-0.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.5c-0.2-0.1-0.4-0.2-0.7-0.3 c-0.3-0.1-0.6-0.1-0.9-0.1h-1.6V9.8h7.1v1.1h-2.6c0.2,0.2,0.3,0.4,0.4,0.7c0.1,0.3,0.2,0.5,0.2,0.8h2v1.1h-2.1 c-0.1,0.6-0.4,1.2-0.8,1.6c-0.4,0.5-1,0.8-1.6,0.9v0c0.2,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.3,0.2,0.4,0.4c0.1,0.2,0.3,0.3,0.4,0.5 c0.1,0.2,0.3,0.4,0.4,0.6l2,3.3L18.2,21.1z M30.6,16L29,14.7c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.2-0.2,0.4-0.2 c0.1,0,0.3,0,0.4,0.1l0.7,0.6C30.1,7.2,24.2,1.5,16.9,1.5c-6.2,0-11.5,4.2-13.1,10.1c0,0.1-0.1,0.3-0.2,0.3C3.5,12,3.4,12,3.2,12 c-0.1,0-0.3-0.1-0.3-0.2c-0.1-0.1-0.1-0.3-0.1-0.4C4.5,4.9,10.3,0.4,16.9,0.4c7.8,0,14.2,6.2,14.5,14l0.7-0.6 c0.1-0.1,0.3-0.1,0.4-0.1c0.1,0,0.3,0.1,0.4,0.2c0.2,0.2,0.2,0.5,0,0.7L31.3,16c-0.1,0.1-0.2,0.1-0.3,0.1 C30.8,16.1,30.7,16.1,30.6,16L30.6,16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecharge);
export default __webpack_public_path__ + "static/media/recharge.86c072c17e955e77733eba93b7eb666b.svg";
export { ForwardRef as ReactComponent };